import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import {
  Button, ButtonColour, ButtonSize, Typography,
} from "@trussle/external-components";
import { IContentfulHeroProps } from "../../types/IHero";
import { PanelWrapper } from "../PanelWrapper";
import "./styles.scss";
import { trackEvent } from "../../helpers/analytics";
import { getPlainText } from "../../utils/getPlainText";

const HeroSimpleBetterV2: React.FC<IContentfulHeroProps> = ({
  heading1,
  heading2,
  firstCta,
}) => {
  const handleClick = async () => {
    await trackEvent(`${firstCta?.title} button clicked`, {
      module: "HeroSimpleBetterV2",
      element_type: "Button",
      section: "Hero",
    });

    window.location.assign(firstCta?.url || "#");
  };

  return (
    <PanelWrapper isBetterV2 className="hero-simple-betterv2-panel-wrapper">
      <div className="hero-simple-betterv2-container">
        <div className="hero-simple-betterv2-heading1">
          {heading1 && <Typography variant="h1" component="h1">{getPlainText(heading1)}</Typography>}
        </div>
        {heading2 && renderRichText(heading2)}
        {firstCta && (
          <div className="hero-simple-betterv2-content">

            <Button
              size={ButtonSize.Large}
              colour={ButtonColour.Black}
              onClick={handleClick}
            >
              {firstCta?.title}
            </Button>

          </div>
        )}
      </div>
    </PanelWrapper>
  );
};

export default HeroSimpleBetterV2;
